import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { AnalyticsHelperService } from "../../services/analytics-helper.service";

@Component({
    selector: "app-button",
    templateUrl: "./button.component.html",
    styleUrls: ["./button.component.scss"]
})
export class ButtonComponent implements OnInit {
    @Input() text!: string;
    @Input() path!: string;
    @Input() tab!: string;
    @Input() link!: string;
    @Input() type: string;
    @Input() variation: string = "";
    @Input() icon: string = "";
    @Input() openInNewTab: boolean = false;
    @Input() disableButton: boolean = false;

    @Output() btnClick: EventEmitter<void> = new EventEmitter<void>();

    @Input() public disabled: boolean = false;
    @Input() public resetAfterEvent: boolean = false;

    public isActive: boolean = false;

    public eventTimeout: any;

    constructor(private router: Router, private analyticsHelper: AnalyticsHelperService) {}

    ngOnInit() {
        this.typeButton();
    }

    onClick() {
        this.btnClick.emit();

        setTimeout(() => {
            if (this.path) {
                this.goToRoute();
            } else if (this.link) {
                window.location.href = this.link;
            }
        }, 0);
    }

    goToRoute() {
        if (this.openInNewTab) {
            window.open(this.path);
        } else {
            if (this.path && this.tab) {
                this.router.navigate([this.path], { fragment: this.tab });
            } else if (this.path) {
                this.router.navigate([this.path]);
            }
        }
    }

    public onButtonClicked() {
        this.isActive = true;
        if (this.resetAfterEvent) {
            this.resetButton();
        }
    }

    private resetButton() {
        this.isActive = false;
    }

    private typeButton() {
        if (!this.type) {
            this.type = "button";
        }
    }
}
